import { render } from "./Yearly.vue?vue&type=template&id=fc3812b6"
import script from "./Yearly.vue?vue&type=script&lang=js"
export * from "./Yearly.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lolo/projects/mygpsworkouts-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__